module.exports = __webpack_public_path__ + "img/team11.e9e29500.jpg";